import { watch } from 'vue'
import { deepToRaw } from '@/utils/deepToRaw'
import { useAuthStore } from '@/ContextTab/stores/auth/auth'
import { tabMetrics } from '@/ContextTab/services/tabMetrics'


export async function usePassAuth() {

  const authStore = useAuthStore()

  return async (legacyApp: any) => {
    if (authStore.isAuthorized) {
      await legacyApp.$store.dispatch('auth/start', {
        userId: authStore.userId,
        login: authStore.login,
        accessToken: authStore.accessToken,
        refreshToken: authStore.refreshToken,
        permissions: deepToRaw(authStore.tokenData?.permissions ?? {}),
      })
    } else {
      tabMetrics.sendException('Legacy mounted, but auth not made')
    }

    watch(() => authStore.sessionId, (sessionId) => {
      legacyApp.$store.$sessionId = sessionId // $sessionId, not sessionId
    }, {
      immediate: true,
    })
  }
}
